var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSchoolInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_62902)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 24,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 44.7999C37.2786 44.7999 44.8002 37.2783 44.8002 28C44.8002 18.7216 37.2786 11.2 28.0002 11.2C18.7218 11.2 11.2002 18.7216 11.2002 28C11.2002 37.2783 18.7218 44.7999 28.0002 44.7999Z",
    fill: "url(#paint0_linear_3_62902)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5692 18.6667H24.4386C21.2578 18.6667 18.6743 21.2502 18.6743 24.431V31.5617C18.6743 34.7425 21.2578 37.3259 24.4386 37.3259H31.5692C34.75 37.3259 37.3335 34.7425 37.3335 31.5617V24.431C37.3335 21.2502 34.75 18.6667 31.5692 18.6667ZM35.2503 31.5691C35.2503 33.6001 33.6002 35.2577 31.5618 35.2577H24.4311C22.4002 35.2577 20.7426 33.6075 20.7426 31.5691V24.4385C20.7426 22.4075 22.3927 20.7499 24.4311 20.7499H31.5618C33.5927 20.7499 35.2503 22.4001 35.2503 24.4385V31.5691Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 23.229C25.3719 23.229 23.229 25.3719 23.229 28.0002C23.229 30.6285 25.3719 32.7714 28.0002 32.7714C30.6285 32.7714 32.7714 30.6285 32.7714 28.0002C32.7714 25.3719 30.6285 23.229 28.0002 23.229ZM28.0002 30.8973C26.4023 30.8973 25.1031 29.5981 25.1031 28.0002C25.1031 26.4023 26.4023 25.1031 28.0002 25.1031C29.5981 25.1031 30.8973 26.4023 30.8973 28.0002C30.8973 29.5981 29.5981 30.8973 28.0002 30.8973Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.134 23.7519C33.5736 23.6806 33.8722 23.2665 33.8009 22.8269C33.7297 22.3874 33.3156 22.0888 32.876 22.16C32.4364 22.2313 32.1378 22.6454 32.2091 23.085C32.2804 23.5246 32.6945 23.8231 33.134 23.7519Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_62902",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_62902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_62902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_62902",
    x1: 15.2082,
    y1: 40.7919,
    x2: 39.0829,
    y2: 16.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchoolInstagram);
export default __webpack_public_path__ + "static/media/icon_school_instagram.71b0b9e8ac32e6eab9e70c57e07fa08b.svg";
export { ForwardRef as ReactComponent };